/* global $:false */

export default class BidHistory {
  static init () {
    if ($('.js-push-live-page-bid-history').length < 1) { return }

    if (this.instance) {
      this.instance._unHideMyBidMarkers()
    } else {
      this.instance = new BidHistory()
    }
  }

  constructor () {
    $('html').on('click', '.js-bid-history-toggle', event => {
      $(event.target)
        .parents('.js-push-live-page-bid-history')
        .toggleClass('c-bid-history-items--view-more')
    })

    document.addEventListener('htmlPush:afterReplace', event => { this._unHideMyBidMarkers() })
    this._unHideMyBidMarkers()
  }

  _unHideMyBidMarkers () {
    $('.js-push-live-page-bid-history')
      .find(`.c-bid-history-item[data-bid-card-id=${this._myBidCardId()}] .c-bid-history-item__your_bid`)
      .addClass('c-bid-history-item__your_bid--visible')
  }

  _myBidCardId () {
    return $('.js-push-live-page-bid-history').data('bid-card-id')
  }
}
